import { Space } from 'antd';
import styled from 'styled-components';
import { BodyLong01 } from 'components/styles';

const SIDEBAR_WIDTH = 255;

export const NewTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow-y: scroll;
  padding: 0;
`;

export const BreadcrumbContainer = styled(Space).attrs({
  direction: 'horizontal',
  size: 0,
  align: 'center',
})`
  padding: var(--spacing-05) var(--spacing-05) 0;

  button {
    padding: var(--spacing-03);
  }

  span {
    ${BodyLong01};
  }
`;

export const Layout = styled.div<{ headerheight?: number }>`
  display: flex;
  flex: auto;
  flex-direction: row;
  min-height: 0;
  background: #fff;
  height: calc(100vh - 102px);
`;

// sidebar with open menu inline is causing some overlap issue
// hence the custom layout
export const SiderContent = styled.div`
  width: calc(${SIDEBAR_WIDTH}px - 2px);
  height: 100%;
`;
export const Sider = styled.div<{ $hide?: boolean }>`
  width: ${({ $hide }) => ($hide ? '0px' : `${SIDEBAR_WIDTH}px`)};
  ${SiderContent} {
    transition: all 0.1s cubic-bezier(0.29, 0.04, 0.23, 1);
    transform: ${({ $hide }) =>
      $hide ? 'translateX(-100%)' : 'translateX(0)'};
  }
  border: 1px solid var(--gray-10);
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  transition: all 0.3s cubic-bezier(0.29, 0.04, 0.23, 1);
`;

export const Content = styled(Layout)`
  flex-direction: column;
  flex: auto;
  min-height: 0;
  height: 100%;
  width: calc(100vh - ${SIDEBAR_WIDTH}px);
`;
